import { useNavigate } from 'react-router-dom';
import { AddOnForm } from '../components/AddOnForm';
import { useAddOnMutations } from '../hooks/useAddOnMutations';
import type { AddOnFormValues } from '../schemas/addon.schema';

export function AddOnCreate() {
    const navigate = useNavigate();
    const { createMutation } = useAddOnMutations();

    const handleSubmit = (data: AddOnFormValues) => {
        createMutation.mutate(
            { name: data.name, description: data.description, category: data.category, price: data.price, vat_category_id: data.vat_category_id },
            { onSuccess: (created) => navigate(`/smr-admin/addons/${created.id}`) },
        );
    };

    return (
        <section className="space-y-4">
            <h1 className="text-2xl font-semibold">New Optional Extra</h1>
            <AddOnForm onSubmit={handleSubmit} isLoading={createMutation.isPending} submitLabel="Create Optional Extra" />
        </section>
    );
}
